import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  LoginRequest,
  LoginResponse,
  RoleResponse,
  SocietyResponse,
  UserResponse,
} from "../../types/api.types";
import { LoginFormData } from "../../components/LoginForm";
import { Society } from "../../types/api.types";

export const societyService = {
  getSocietyById: async (id: string): Promise<Society> => {
    const response = await apiClient.get<ApiResponse<Society>>(
      ENDPOINTS.SOCIETIES.GET_BY_ID,
      { params: { companyId: id } }
    );
    return response.data.data;
  },
  createSociety: async (societyData: any): Promise<SocietyResponse> => {
    const response = await apiClient.post<ApiResponse<SocietyResponse>>(
      ENDPOINTS.SOCIETIES.CREATE,
      societyData
    );
    return response.data.data;
  },
  getSocieties: async (
    currentPage: number,
    pageSize: number,
    search?: string
  ): Promise<SocietyResponse> => {
    const response = await apiClient.get<ApiResponse<SocietyResponse>>(
      ENDPOINTS.SOCIETIES.GET_ALL,
      {
        params: {
          page: currentPage,
          rowPerPage: pageSize,
          ...(search && { search }),
        },
      }
    );
    return response.data.data;
  },
  deactivateSociety: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.SOCIETIES.DEACTIVATE,
      {},
      { params: { id } }
    );
    return response.data;
  },
  activateSociety: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.SOCIETIES.ACTIVATE,
      {},
      { params: { id } }
    );
    return response.data;
  },
  updateSociety: async (
    id: string,
    societyData: any
  ): Promise<SocietyResponse> => {
    const response = await apiClient.put<ApiResponse<SocietyResponse>>(
      ENDPOINTS.SOCIETIES.UPDATE,
      { ...societyData, companyId: id }
    );
    return response.data.data;
  },
};
